import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawayBrief = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/productivity-host/briefs/giveaways' });

  return data;
};

export default getGiveawayBrief;
